import { createValidation } from '../../../utils/validation';
export const createComplaintSampleAvailableValidation = (fields) => { const validation = createValidation(fields); return { schema: validation.schema, validateData: validation.validateData, validateComplaintSampleAvailableData: validation.validateData, validateField: validation.validateField }; };
export default createComplaintSampleAvailableValidation;

